import classnames from 'classnames';

import { mobileDevice } from '@bingads-webui-campaign-react/common-hooks';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getDialogFullBorder, getDialogStyle } from './dialog-style';

export const sectionTitleStyles = {
  fontWeight: 'bold',
  fontSize: 14,
  lineHeight: '16px',
  marginTop: 5,
  marginBottom: 5,
};

const getStyles = (_, { palette = {} }) => ({
  title: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '20px',
    margin: '16px 20px 12px 20px',
  },
  description: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '20px',
    marginTop: 16,
    marginBottom: 16,
    margin: '16px 20px',
  },
  editorContent: {
    margin: '0 40px 0 20px',
    [mobileDevice]: {
      margin: '0 20px',
    },
  },
  editorImgsContent: {
    marginLeft: '16px',
  },
  sectionTitle: sectionTitleStyles,
  dialogFullBorder: {
    ...getDialogFullBorder(_, { palette }),
  },
  dialog: {
    ...getDialogStyle(_, { palette }),
  },
  infoMessageBar: {
    '& .ms-MessageBar-content': {
      background: palette.themeLighterAlt,
    },
    '@media (forced-colors: active)': {
      'forced-color-adjust': 'auto',
    },
  },
  choiceGroup: {
    marginLeft: 8,
  },
  editorPivotStyleContent: {
    margin: '5px 0 15px 10px',
    paddingBottom: '10px',
  },
  uploadButton: {
    marginLeft: 0,
  },
});

export const useDefaultEditorStyle = () => {
  const {
    title,
    description,
    sectionTitle,
    dialog,
    dialogFullBorder,
    editorContent,
    editorImgsContent,
    infoMessageBar,
    choiceGroup,
    editorPivotStyleContent,
    uploadButton,
  } = useDefaultStyles(getStyles);

  return {
    titleClassName: classnames(title, 'smart-page-component-editor-title'),
    descriptionClassName: classnames(description, 'smart-page-component-editor-description'),
    sectionTitleClassName: sectionTitle,
    dialogClassName: dialog,
    dialogFullBorderClassName: dialogFullBorder,
    editorContentClassName: editorContent,
    editorImgsContentClassName: editorImgsContent,
    infoMessageBarClassName: infoMessageBar,
    choiceGroupClassName: choiceGroup,
    editorPivotStyleContentClassName: editorPivotStyleContent,
    uploadButtonClassName: uploadButton,
  };
};
